<template>
    <div
        class="md-house layout5 mg-bg"
        v-if="result && result.listings && result.listings.length > 0"
        :style="{ ...spaceStyle, ...colorStyle, background: bgColor  }"
    >
        <div class="layout5-inner">
            <div class="title-wrap f-col" v-if="title || desc">
                <site-title
                    :title="title"
                    class="house-title"
                ></site-title>
                <site-sub-title class="desc" :title="desc"></site-sub-title>
            </div>
            <list :maskOption="maskOption" />
            <site-button
                v-if="moreShow && moreText"
                type="plain"
                :html="moreText"
                class="button-more"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                rel="noopener noreferrer"
            ></site-button>
        </div>
    </div>
</template>
<script>
import Core from '../index.js';
import list from './list.vue';
export default {
    mixins: [Core],
    components: { list },
    provide() {
        return {
            maskOption: this.maskOption
        };
    },
    data: function() {
        return {};
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-house.layout5 {
    @include media-800 {
        padding-bottom: 20px;
    }
    .layout5-inner {
        position: relative;
        .title-wrap {
            margin-bottom: 30px;
            .desc {
                margin-top: 10px;
            }
            @include media-800 {
                margin-bottom: 15px;
            }
        }
    }
    .button-more {
        text-align: center;
        font-family: var(--font-normal);
        font-weight: 400;
        display: flex;
        font-size: 16px;
        width: 220px;
        height: 50px;
        margin: 50px auto 0 auto;
        background-color: transparent;
        border: 1px solid var(--g-btn-background);
        color: var(--g-btn-background);
        @include media-800 {
            margin: 20px auto 0 auto;
        }
    }
    .layout5-house-swiper {
        position: relative;

        .swiper {
            margin-left: auto;
            margin-right: auto;
            position: relative;
        }
        .swiper-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            z-index: 1;
            transition-property: transform;
            display: flex;
            align-items: center;
            @include media-800 {
                flex-direction: column;
            }
        }
        .swiper-slide {
            transition-duration: 0ms;
            width: 100%;
            z-index: 0;
            .house-slider-item {
                width: 100%;
                height: 620px;
                @include media-800 {
                    height: 400px;
                }
            }
        }
        .swiper-slide-active {
            z-index: 1;
        }
        @include media-800 {
            .swiper {
                position: static;
            }
            .swiper-wrapper {
                position: static;
                transition-property: none;
                flex-direction: column;
                transform: translate3d(0,0,0) !important;
            }
            .swiper-slide {
                .house-slider-item {
                    @include media-800 {
                        height: 400px;
                    }
                }
            }
        }

        .button-swiper {
            position: absolute;
            z-index: var(--level-low);
            width: 100%;
            height: 50px;
            top: 50%;
            transform: translateY(-50%);
            .house-next,
            .house-prev {
                position: absolute;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                line-height: 50px;
                text-align: center;
                cursor: pointer;
                color: var(--g-btn-color);
                border: 1px solid var(--g-btn-color);
                &.house-swiper-disabled,
                &.swiper-button-lock {
                    cursor: not-allowed;
                    display: block;
                    opacity: 0.3;
                }
                &:hover::after{
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(25, 25, 25, 0.1);
                }
            }
            .house-prev {
                left: 50px;
                transform: rotate(-90deg);
            }
            .house-next {
                right: 50px;
                transform: rotate(90deg);
            }
            .iconfont {
                font-size: 20px;
            }
            @include media-800 {
                display: none;
            }
        }
    }
}
</style>
